import { useEffect } from 'react';
import { logEvent } from '@/config/analytics';
import type { Translator } from '@/i18n';
import { HeroAction } from './HeroAction';
import { Icon } from './Icon';

interface Props {
  t: Translator['t'];
  /** Ідентифікатор із посилання пройшов перевірку формату. */
  valid: boolean;
  onJoin: () => void;
  onCreateOwn: () => void;
}

/**
 * Екран гостя: сторінку відкрили за посиланням на кімнату.
 *
 * Гість — людина, якій надіслали посилання, і саме вона найчастіше не має
 * застосунку. Раніше вона проходила 7 слайдів туторіалу хоста. Тепер одна
 * основна дія; натискання «Приєднатися» — і є той жест, у межах якого браузер
 * запитує камеру й мікрофон. Банера згоди тут немає: він не має відволікати
 * від входу в дзвінок.
 */
export function GuestScreen({ t, valid, onJoin, onCreateOwn }: Props): React.JSX.Element {
  useEffect(() => {
    logEvent('guest_screen_shown');
  }, []);

  return (
    <main className="start">
      <div className="dialog">
        <div className="dialog__inner guest">
          <div className="guest__ring" aria-hidden="true">
            <span className="guest__ring-inner">
              <Icon name={valid ? 'videocam' : 'link_off'} size={38} />
            </span>
          </div>
          <h1 className="dialog__title guest__title">
            {valid ? t('guestTitle') : t('guestInvalidTitle')}
          </h1>
          <p className="guest__body">{valid ? t('guestBody') : t('guestInvalidBody')}</p>

          <div className="guest__primary">
            <HeroAction
              icon={valid ? 'videocam' : 'add'}
              liveDot={valid}
              title={valid ? t('guestJoin') : t('guestCreateOwn')}
              onClick={valid ? onJoin : onCreateOwn}
            />
          </div>

          {valid && (
            <>
              <p className="guest__note">{t('guestFreeNote')}</p>
              <button type="button" className="link-button" onClick={onCreateOwn}>
                {t('guestCreateOwn')}
              </button>
            </>
          )}
        </div>
      </div>
    </main>
  );
}
